<template>
	<div class="inner-modal inner-modal--acc">
		<div class="acc">
			<div class="acc__inner">
				<div class="acc__form">
					<div class="acc__head">
						<h3 class="acc__heading">Reset Password</h3>
						<p>Enter your new password below.</p>
						<template v-if="validationErrors.length">
							<template v-for="error in validationErrors">
								<p class="text-danger">{{error}}</p>
							</template>
						</template>
					</div>
					<div class="form-group">
						<label for="emailAddress">Email address<span class="text-danger">*</span></label>
						<input type="email" v-model="resetPasswordInfo.emailAddress" id="emailAddress" :class="[`form-control`, formValidationErrors?.emailAddress?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.emailAddress">
							&bull; {{error}}
						</div>
					</div>
					<div class="form-group">
						<label for="password">Password<span class="text-danger">*</span></label>
						<input type="password" v-model="resetPasswordInfo.password" id="password" :class="[`form-control`, formValidationErrors?.password?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.password">
							&bull; {{error}}
						</div>
					</div>
					<div class="form-group">
						<label for="confirmPassword">Confirm Password<span class="text-danger">*</span></label>
						<input type="password" v-model="resetPasswordInfo.confirmPassword" id="confirmPassword" :class="[`form-control`, formValidationErrors?.confirmPassword?.length ? 'is-invalid' : '']">
						<div class="invalid-feedback" v-for="error in formValidationErrors?.confirmPassword">
							&bull; {{error}}
						</div>
					</div>
					<div class="text-center mt-3">
						<Cta type="primary" size="lg" label="Update" @onClick="update" :icon="[]" iconAlignment="left"> </Cta>
					</div>
				</div>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import {computed, ref, onMounted} from 'vue';

const componentName = 'AccountForgotPasswordModal';

import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
const store = useStore();
import { useRouter, useRoute } from 'vue-router';
const route = useRoute();
import {UserLogin, UserResetPassword} from "Api/apis";
const router = useRouter();
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});
import {useToast} from 'vue-toastification';

const toast = useToast();

const resetPasswordInfo = ref<{ emailAddress: string, vk: string, password: string, confirmPassword: string }>({
	vk: "",
	emailAddress: "",
	password: "",
	confirmPassword: "",
});

const props = defineProps({
	pathPrefix: String
});

const update = async() => {
	await UserResetPassword(resetPasswordInfo.value).then(async(response) => {
		if(response.data) {
			await store.commit('updateAuthToken', response.data.authToken);
			toast.success(`You successfully reset your password`, {
				timeout: false
			});
			setTimeout(() => {
				let baseURL = window.location.protocol + "//" + window.location.host;
				window.location.href = `${baseURL}${props.pathPrefix}`;
			}, 2000);
		} else {
			if(response.isErrors) {
				if(response.errorDetail.isError) {
					validationErrors.value = response.userFriendlyMessages;
				}
				if(response.formValidationMessages) {
					formValidationErrors.value = response.formValidationMessages;
				}
			}
		}
	});
};


const closeModal = async() => {
	await store.dispatch('closeModal');
	let baseURL = window.location.protocol + "//" + window.location.host;
	window.location.href = `${baseURL}${props.pathPrefix}`;
};

onMounted(() => {
	//route is not working here for some reason so using URLSearchParams
	const urlParams = new URLSearchParams(window.location.search);
	resetPasswordInfo.value.vk = urlParams.get('vk');
});
</script>
